/**
 * An hour, as a parent reads it: "Thu 9 Oct, 16:00".
 *
 * Extracted when the released-hours banner needed the same phrasing the cart
 * screen already used. Two screens naming the same moment in two formats is the
 * kind of difference nobody notices until a parent is comparing the banner with
 * the cart and cannot tell whether they are looking at one hour or two.
 *
 * `toLocaleString` renders in the BROWSER's timezone, which is right here and
 * only here: a parent booking a cage in Redmond from Vancouver should see the
 * time they will turn up at, and both are the same wall clock. It stops being
 * right the day a coach in another timezone publishes hours, and that is the day
 * the facility's timezone has to come down with the slot.
 */
export function when(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: '2-digit',
  });
}
